module.exports = __webpack_public_path__ + "img/AirElemental.9008912e.jpg";